import { PostLiveShowInfo } from '@/Interfaces/I_LiveShow';
import { customAxios } from '../index';

const getLiveShowInfoAPI = () => customAxios.get('/hktv_koc/cms/live_show/info');

const postLiveShowInfoAPI = (data: PostLiveShowInfo) =>
  customAxios.post('/hktv_koc/cms/live_show/info', data);

export { getLiveShowInfoAPI, postLiveShowInfoAPI };
